import { render, staticRenderFns } from "./urgent-shipin.vue?vue&type=template&id=0584cf58&scoped=true"
import script from "./urgent-shipin.vue?vue&type=script&lang=js"
export * from "./urgent-shipin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0584cf58",
  null
  
)

export default component.exports